/**
 * Live refs for Ella Radio session callbacks.
 * radioRefill reads these on every continue so weather/time/bedtime stay current.
 */

export interface EllaRadioSessionRefs {
  ellaPlaylistId: string | null;
  buildTuningParams: () => Record<string, unknown>;
  getPlayedTrackIds: () => string[];
  getSkippedTrackIds: () => string[];
  getTweaks: () => string[] | undefined;
  onTracksAppended?: (tracks: unknown[]) => void;
  /** Ella speaks when a live weather/time moment is queued up next. */
  onMomentInterrupt?: (ellaResponse: string, tracks: unknown[]) => void;
  /** Ella speaks when ambient re-weave shifts or reverts the fluid queue. */
  onAmbientReweave?: (ellaLine: string, direction: 'shift' | 'revert') => void;
  /** Session ends gracefully after reserve + retries exhausted. */
  onSessionEndGraceful?: (ellaLine: string) => void;
  timeAware: boolean;
  weatherAware: boolean;
  bedtimeHour: number | null;
  lat: number | null;
  lon: number | null;
  locationCity: string | null;
  locationRegion: string | null;
}

const defaultRefs: EllaRadioSessionRefs = {
  ellaPlaylistId: null,
  buildTuningParams: () => ({}),
  getPlayedTrackIds: () => [],
  getSkippedTrackIds: () => [],
  getTweaks: () => undefined,
  timeAware: true,
  weatherAware: true,
  bedtimeHour: null,
  lat: null,
  lon: null,
  locationCity: null,
  locationRegion: null,
};

export const ellaRadioSessionRefs: EllaRadioSessionRefs = { ...defaultRefs };

export function syncEllaRadioSessionRefs(patch: Partial<EllaRadioSessionRefs>): void {
  Object.assign(ellaRadioSessionRefs, patch);
}

export function resetEllaRadioSessionRefs(): void {
  Object.assign(ellaRadioSessionRefs, defaultRefs);
  ellaRadioSessionRefs.onTracksAppended = undefined;
  ellaRadioSessionRefs.onMomentInterrupt = undefined;
  ellaRadioSessionRefs.onAmbientReweave = undefined;
  ellaRadioSessionRefs.onSessionEndGraceful = undefined;
}
